/**
 * Format bytes into human-readable file sizes.
 *
 * @param bytes - Number of bytes to format
 * @param decimals - Number of decimal places to show (default: 2)
 * @returns Formatted file size string (e.g., "1.5 MB")
 */
export const formatFileSize = (bytes: number, decimals = 2): string => {
  // Handle edge cases: bytes <= 0 or falsy → return "0 Bytes"
  if (!bytes || bytes < 1) {
    return "0 Bytes";
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  // Clamp size index to prevent array overflow
  const clampedIndex = Math.min(i, sizes.length - 1);

  const value = bytes / Math.pow(k, clampedIndex);
  const formattedValue = parseFloat(value.toFixed(dm));

  return formattedValue + " " + sizes[clampedIndex];
};

// Export formatBytes as alias for backward compatibility
export const formatBytes = formatFileSize;
